import {useContext} from 'react';
import {globalUIContext} from '../utils/global-ui-helpers';
import {HELP_AND_SUPPORT_MODAL} from '../constants/modals';
import {
  ExternalLink,
  PRIVACY_POLICY,
  PRODUCT_TERMS_OF_USE,
  WEBSITE_TERMS_OF_USE,
} from '../../components/shared/external-link';
import '../globals';

export const Footer = () => {
  const {openModal} = useContext(globalUIContext);
  return (
    <footer
      className="flex flex-wrap items-center justify-center h-12 mt-8 shrink-0 [&_a]:no-underline [&_a]:ml-3 [&_a]:mr-3 [&_a]:text-xs [&_a]:font-normal [&_a]:leading-6 hover:[&_a]:underline"
      style={{color: 'rgb(0, 106, 225)'}}
    >
      <a
        href="#"
        onClick={(event) => {
          event.preventDefault();
          openModal(HELP_AND_SUPPORT_MODAL);
        }}
        aria-label="help and support link"
        style={{color: 'inherit'}}
      >
        Help & Support
      </a>
      <ExternalLink type={PRODUCT_TERMS_OF_USE} />
      <ExternalLink type={WEBSITE_TERMS_OF_USE} />
      <ExternalLink type={PRIVACY_POLICY} />
      {window?.useOneTrust ? (
        <a
          href="#"
          onClick={(event) => {
            event.preventDefault();
            window?.OneTrust?.ToggleInfoDisplay?.();
          }}
          aria-label="privacy preference center link"
          style={{color: 'inherit'}}
        >
          Privacy Preference Center
        </a>
      ) : null}
    </footer>
  );
};
